/* ==========================================================================
   SHIRTPLUS — SP-800-036: AVIS-Konfiguration beim Leeren des Warenkorbs
   vollstaendig zuruecksetzen
   ==========================================================================

   ZIEL (Ticket Abschnitt 1/5)
   Sobald der Warenkorb komplett leer ist (`/cart.js` -> item_count === 0),
   wird der clientseitige Entwurfs-/Formularzustand des AVIS-Konfigurators
   auf der aktuell offenen Seite zurueckgesetzt, damit eine anschliessend neu
   geoeffnete AVIS-Konfiguration wieder vollstaendig leer startet. Greift
   NICHT ein, solange der Warenkorb noch mindestens eine Position enthaelt
   (Ticket Abschnitt 4/8: Entfernen einer einzelnen Gruppe darf andere aktive
   Konfigurationen nicht beeinflussen).

   ROOT-CAUSE-BEFUND (live verifiziert, siehe
   SP_800_036_AVIS_CART_CLEAR_RESET_REPORT.md fuer die volle Herleitung)
   Live auf der echten AVIS-Konfigurationsflaeche ("Jetzt veredeln"-Modal,
   Produkt "Latzschürze Colours PW150") wurden ALLE in Ticket Abschnitt 3
   geforderten Speicherorte einzeln geprueft:
     - localStorage: kein einziger AVIS-bezogener Key vorhanden (0 Treffer
       bei Voll-Scan aller vorhandenen Keys UND aller Werte).
     - sessionStorage: kein einziger AVIS-bezogener Key vorhanden.
     - Cookies: keine AVIS-bezogenen Cookies vorhanden.
     - IndexedDB: keine Datenbanken vorhanden.
   Die AVIS-App haelt ihren Entwurfszustand ausschliesslich in
   Seiten-lokalem JavaScript-Speicher (window-Objekte, u. a. window.AVIS_FG_DATA
   ["Form Group Data"], window.AVIS_FG_CURRENT, window.AVIS_AOV_CACHE) sowie
   im DOM (sichtbare Radios/Textfelder + der verdeckte Container
   .avis-input-hiddens). Live bestaetigt: window.AVIS_FG_DATA behaelt vom
   Kunden eingegebene, aber nicht gespeicherte Werte (z. B. eine getippte
   Bemerkung) auch dann, wenn das Modal geschlossen und die sichtbaren
   Formularfelder dabei augenscheinlich zurueckgesetzt werden - ein "Ghost
   State", der bei einer erneuten Modal-Interaktion theoretisch wieder
   einfliessen kann. Da keine dieser Groessen in echtem Browser-Storage
   liegt, ueberlebt sie KEINEN echten Seiten-Reload/-Wechsel (bestaetigt:
   ein frischer Seitenaufruf startet AVIS_FG_DATA leer). Dieses Skript setzt
   den bekannten, erreichbaren Entwurfszustand dennoch aktiv zurueck, sobald
   der Warenkorb leer ist - als Sicherheitsnetz fuer alle Faelle, in denen
   Kunde und AVIS-Modal ohne vollstaendigen Seiten-Reload auf derselben
   Seite verbleiben (z. B. Zwischenspeicherung durch die App selbst bei
   einer kuenftigen AVIS-Version, oder Browser-Vor-/Zurueck-Navigation ueber
   den Cache).

   WAS DIESES SKRIPT NICHT ANFASST (Ticket Abschnitt 2/14)
   Keine AVIS-App-Dateien, keine AVIS-App-Konfiguration. Ausdruecklich NICHT
   angefasst werden alle Produkt-/Options-Definitionen und Rendering-
   Funktionen der App (u. a. AvisOptionsConfig, avisOpions, AvisOptionsData,
   apoThemeConfigs, apoOptionLocales, AvisStyleOptions, apoProductDefault,
   AvisOptionProductIds, AvisSwatchVariantsItem, avisUpsellMap, apo_MiniCart,
   apoPhoneInput*, apoCalPrice, initAvis, loadAvisOption und alle sonstigen
   Funktionen). Nur die live als reiner Kunden-Entwurfszustand identifizierten
   Objekte (AVIS_FG_DATA, AVIS_FG_CURRENT, AVIS_AOV_CACHE) und sichtbare
   Formularwerte werden geleert - niemals geloescht/neu zugewiesen, sondern
   in-place entleert, damit von der App gehaltene Referenzen auf dasselbe
   Objekt weiter funktionieren. Keine Datei wird auf dem AVIS-CDN geloescht
   (Ticket Abschnitt 11) - nur lokale Referenzen/Anzeigen.

   EVENT-FLOW (Ticket Abschnitt 7)
   Bevorzugt werden die im Theme bereits vorhandenen Cart-Events genutzt
   (kein Polling, keine neue Cart-Integritaetslogik):
     - `cart:change` (nativ vom Theme dispatched nach jeder Mengenaenderung/
       jedem Entfernen ueber Cart Drawer, Warenkorbseite, Plus-/Minus-Buttons,
       direkte Mengeneingabe - siehe assets/theme.js).
     - `cart:refresh` (von assets/sp-cart-integrity.js nach einer AVIS-
       Mengenkorrektur dispatched, z. B. wenn durch Entfernen des
       Hauptprodukts verwaiste Aufpreiszeilen automatisch mitentfernt werden).
   Zusaetzlich als Sicherheitsnetz fuer Warenkorb-Aenderungen, die NICHT ueber
   diese beiden Events laufen (z. B. ein direkter Aufruf von /cart/clear.js
   ausserhalb der Theme-eigenen Bedienelemente, Ticket Abschnitt 4C): ein
   eng gescopter, ausschliesslich auf die vier Shopify-Ajax-Cart-Endpunkte
   (clear.js/change.js/update.js/remove.js) begrenzter fetch()-Wrapper nach
   demselben, bereits von der AVIS-App selbst verwendeten Muster
   (vgl. window.__apoCartFetchPatched). Nach jedem dieser Aufrufe wird der
   tatsaechliche Server-Zustand per GET /cart.js (kein weiterer Mutations-
   Request) geprueft - kein Rueckkanal, der einen erneuten Lauf ausloesen
   koennte, keine Endlosschleife.

   KEINE MEHRFACHAUSFUEHRUNG / KEIN POLLING (Ticket Abschnitt 7/8)
   Ein `hasResetForThisEmptyState`-Flag sorgt dafuer, dass der Reset erst
   dann erneut auslösen kann, wenn der Warenkorb zwischenzeitlich wieder eine
   Position enthielt (item_count > 0). Solange der Warenkorb bereits leer
   ist, wird bei jedem weiteren Event kein zusaetzlicher Reset und kein
   zusaetzlicher Request ausgeloest. Entfernen einer einzelnen Gruppe bei
   weiterhin nicht-leerem Warenkorb loest keinerlei Reset aus (Ticket
   Abschnitt 8/9).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__spAvisCartResetLoaded) return;
  window.__spAvisCartResetLoaded = true;

  var hasResetForThisEmptyState = false;
  var isChecking = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchCartItemCount() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.item_count; });
  }

  // Leert ausschliesslich die live identifizierten Kunden-Entwurfs-Caches der
  // AVIS-App in-place (kein Neuzuweisen der Objekte, siehe Kommentar oben).
  function clearAvisDraftCaches() {
    var draftCacheNames = ['AVIS_FG_DATA', 'AVIS_FG_CURRENT', 'AVIS_AOV_CACHE'];
    draftCacheNames.forEach(function (name) {
      try {
        var obj = window[name];
        if (obj && typeof obj === 'object') {
          Object.keys(obj).forEach(function (key) {
            try { delete obj[key]; } catch (e) { /* einzelnen Key ignorieren, weiter mit den uebrigen */ }
          });
        }
      } catch (e) {
        // Naechsten Cache-Namen unbeeinflusst weiterverarbeiten - niemals
        // die Seite/den Warenkorb durch einen AVIS-internen Aenderung blockieren.
      }
    });
  }

  // Setzt die verdeckten AVIS-Formularinputs (.avis-input-hiddens) auf ihren
  // urspruenglichen, deaktivierten/leeren Zustand zurueck - identisch zu dem
  // live beim frischen Seitenaufruf beobachteten Ausgangszustand.
  function resetAvisHiddenInputs() {
    try {
      var containers = document.querySelectorAll('.avis-input-hiddens');
      containers.forEach(function (container) {
        var inputs = container.querySelectorAll('input');
        inputs.forEach(function (input) {
          try {
            input.value = '';
            input.disabled = true;
          } catch (e) { /* einzelnes Feld ignorieren */ }
        });
      });
    } catch (e) { /* kein .avis-input-hiddens auf dieser Seite vorhanden - kein Fehler */ }
  }

  // Setzt sichtbare AVIS-Formularfelder (Radios/Checkboxen/Text/Textarea)
  // innerhalb erkennbarer AVIS-Container zurueck, falls das Konfigurations-
  // Popup zum Zeitpunkt des Leerens noch im DOM vorhanden ist.
  function resetAvisVisibleControls() {
    try {
      var scopes = document.querySelectorAll(
        '[class*="avis-popup"], [class*="app-avis-product-options"], .sp-pdp-avis'
      );
      scopes.forEach(function (scope) {
        scope.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (el) {
          try { el.checked = false; } catch (e) {}
        });
        scope.querySelectorAll('input[type="text"], input[type="number"], textarea').forEach(function (el) {
          try { el.value = ''; } catch (e) {}
        });
        scope.querySelectorAll('input[type="file"]').forEach(function (el) {
          try { el.value = ''; } catch (e) {}
        });
      });
    } catch (e) { /* kein AVIS-Konfigurator auf dieser Seite offen - kein Fehler */ }
  }

  function resetAvisState() {
    clearAvisDraftCaches();
    resetAvisHiddenInputs();
    resetAvisVisibleControls();
  }

  // Prueft den tatsaechlichen Server-Zustand (nicht nur den Event-Ausloeser)
  // und reagiert ausschliesslich auf einen echten Wechsel zu item_count === 0.
  function checkAndResetIfEmpty() {
    if (isChecking) return;
    isChecking = true;

    fetchCartItemCount().then(function (itemCount) {
      isChecking = false;

      if (itemCount === 0) {
        if (!hasResetForThisEmptyState) {
          hasResetForThisEmptyState = true;
          resetAvisState();
        }
      } else {
        // Warenkorb enthaelt wieder Positionen - naechster Leer-Zustand darf
        // erneut einen Reset ausloesen (Ticket Abschnitt 8: kein globaler
        // Reset, solange noch aktive Gruppen vorhanden sind).
        hasResetForThisEmptyState = false;
      }
    }).catch(function () {
      isChecking = false;
    });
  }

  document.addEventListener('cart:change', checkAndResetIfEmpty);
  document.addEventListener('cart:refresh', checkAndResetIfEmpty);

  // Sicherheitsnetz (Ticket Abschnitt 4C/7): direkte Aufrufe der Shopify Ajax
  // Cart API, die NICHT ueber die Theme-eigenen Bedienelemente laufen und
  // daher kein `cart:change`/`cart:refresh` ausloesen. Eng auf die vier
  // Cart-Mutations-Endpunkte begrenzt - kein pauschaler fetch()-Abfangpunkt,
  // kein Eingriff in andere Netzwerk-Aufrufe der Seite (u. a. nicht in den
  // eigenen, bereits von der AVIS-App selbst gesetzten Fetch-Patch).
  if (!window.__spAvisCartResetFetchPatched && window.fetch) {
    window.__spAvisCartResetFetchPatched = true;
    var originalFetch = window.fetch;
    var MUTATING_CART_ENDPOINTS = ['/cart/clear.js', '/cart/change.js', '/cart/update.js', '/cart/remove.js'];

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isMutatingCartCall = MUTATING_CART_ENDPOINTS.some(function (endpoint) {
        return url.indexOf(endpoint) !== -1;
      });

      var result = originalFetch.apply(this, arguments);

      if (isMutatingCartCall) {
        result.then(function () { checkAndResetIfEmpty(); }).catch(function () {});
      }

      return result;
    };
  }

  // Einmaliger Konsistenz-Check beim Seitenaufruf (analog zu
  // assets/sp-cart-integrity.js) - deckt u. a. den Fall ab, dass der
  // Warenkorb bereits vor dem Laden dieser Seite geleert wurde.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndResetIfEmpty);
  } else {
    checkAndResetIfEmpty();
  }
})();
